import { styled } from '@lessonup/ui-components';
import React from 'react';
import { FocusMode } from '../../store/playerStoreFocusMode.types';
import { FocusModeScreen, FocusModeScreenProps } from './FocusModeScreen';

export type FocusModeOverlayProps = {
  focusMode: FocusMode | null;
  children: React.ReactNode;
  className?: string;
  overlayClassName?: string;
  renderSpinner?: FocusModeScreenProps['renderSpinner'];
};

export const FocusModeOverlay: React.FC<FocusModeOverlayProps> = ({
  focusMode,
  children,
  className,
  overlayClassName,
  renderSpinner,
}) => {
  return (
    <Wrapper className={className} data-hide-first-child={!!focusMode}>
      {children}
      {focusMode && (
        <Overlay>
          <FocusModeScreen className={overlayClassName} focusMode={focusMode} renderSpinner={renderSpinner} />
        </Overlay>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;

  &[data-hide-first-child='true'] > *:first-child {
    visibility: hidden;
  }
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
`;
